import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../'
import { COLOR } from '../../assets'
import { Container, 
        ImageContainer, 
        TitleContainer, 
        Title,
        DescriptionContainer,
        TitleImage,
        TitleImageContainer,
        ArrowLeft } from './index.styled'


const CardMenuInitial = React.memo(({ image, title, delay, description, textImage, klass }) => {
  return (
    <Container delay={delay}>
      <ImageContainer className="image" src={image} />
      <TitleImage>
        <TitleImageContainer src={textImage}/>
      </TitleImage>
      <TitleContainer>
        <Title className="title">{title}</Title>
      </TitleContainer>
      <DescriptionContainer>
      <Text
          className={`${klass} description-menu-cards-component`}
          fontSize="16px"
          color={COLOR.quinary}
          textId={`${description === 'Start Visit' ? 'splash.start-visit' : 'menu-cards.know-more' }`}
        />
        <ArrowLeft className="arrow"/>
      </DescriptionContainer>
    </Container>
  )
})

CardMenuInitial.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string
}

export default React.memo(CardMenuInitial)
